const InputPagamento = (props) => {
  return (
    <input className='w-full px-4 py-1 border rounded-[50px] text-[11px] text-center lg:text-lg' 
    type={props.type} onChange={(e) => props.mudar(e)}
    value={props.value}
    placeholder={props.placeholder}/>
  );
};

export default InputPagamento;
